module.exports = __webpack_public_path__ + "static/media/logotrivo.8f6001c3.png";